import { render, staticRenderFns } from "./131.vue?vue&type=template&id=e7ed6b20&scoped=true&"
var script = {}
import style0 from "./131.vue?vue&type=style&index=0&id=e7ed6b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ed6b20",
  null
  
)

export default component.exports